"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IMAGE_SIZES_LARGE = [
    { width: 540, width2x: 1080, maxWidth: 500 },
    { width: 720, width2x: 1440, maxWidth: 720 },
    { width: 1080, width2x: 2160, maxWidth: 1080 },
    { width: 1440, width2x: 2880, maxWidth: 1440 },
    { width: 1920, width2x: 3840, maxWidth: 1920 },
    { width: 2560, width2x: 3840 }
];
var IMAGE_SIZES_MEDIUM = [
    { width: 540, width2x: 1080, maxWidth: 500 },
    { width: 640, width2x: 1280, maxWidth: 720 },
    { width: 720, width2x: 1440 }
];
var IMAGE_SIZES_SMALL = [
    { width: 320, width2x: 540, maxWidth: 500 },
    { width: 540, width2x: 1080 }
];
var IMAGE_SIZES_TINY = [{ width: 320, width2x: 640 }];
var IMAGE_SIZES_PREVIEW = [{ width: 160, width2x: 320 }];
var IMAGE_SIZES_LARGE_ICON = [{ width: 80, width2x: 160 }];
var IMAGE_SIZES_ICON = [{ width: 40, width2x: 80 }];
function getImageSet(width) {
    switch (width) {
        case 1080: return IMAGE_SIZES_LARGE;
        case 720: return IMAGE_SIZES_MEDIUM;
        case 540: return IMAGE_SIZES_SMALL;
        case 320: return IMAGE_SIZES_TINY;
        case 160: return IMAGE_SIZES_PREVIEW;
        case 80: return IMAGE_SIZES_LARGE_ICON;
        case 40: return IMAGE_SIZES_ICON;
    }
}
exports.getImageSet = getImageSet;
//# sourceMappingURL=image.utils.js.map